var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"ma-0 pa-0",attrs:{"hide-details":"","flat":"","solo":""},scopedSlots:_vm._u([{key:"append",fn:function(){return [[_c('div',{style:(_vm.swatchStyle),on:{"click":function($event){return _vm.$emit('edit')}}})]]},proxy:true}]),model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})
}
var staticRenderFns = []

export { render, staticRenderFns }